export default "__VITE_ASSET__Cdv0fIEi__"